export const faviconLinks = ({ isBlueBranding }) => {
	return isBlueBranding
		? [
				{
					hid: "favicon-png-1",
					rel: "icon",
					type: "image/png",
					sizes: "16x16",
					href: "/wfw-favicon-16.png",
				},
				{
					hid: "favicon-png-2",
					rel: "icon",
					type: "image/png",
					sizes: "32x32",
					href: "/wfw-favicon-32.png",
				},
				{
					hid: "favicon-png-3",
					rel: "icon",
					type: "image/png",
					sizes: "180x180",
					href: "/wfw-favicon-180.png",
				},
				{
					hid: "favicon-png-4",
					rel: "icon",
					type: "image/png",
					sizes: "512x512",
					href: "/wfw-favicon-512.png",
				},
				{
					hid: "favicon-ico",
					rel: "icon",
					type: "image/x-icon",
					sizes: "256x256",
					href: "/favicon.ico",
				},
		  ]
		: [
				{
					hid: "favicon-png-1",
					rel: "icon",
					type: "image/png",
					sizes: "96x96",
					href: "/favicon-96x96.png",
				},
				{
					hid: "favicon-png-2",
					rel: "icon",
					type: "image/png",
					sizes: "48x48",
					href: "/favicon-48x48.png",
				},
				{
					hid: "favicon-ico",
					rel: "icon",
					type: "image/x-icon",
					href: "/favicon.ico",
				},
		  ];
};
